import React from 'react';
import PropTypes from 'prop-types';
import { Doughnut } from 'react-chartjs-2';
import './CompanyDocumentChart.css';

export class CompanyDocumentChart extends React.Component {

    chartOptions = {
        legend: false,
        responsive: true,
        tooltips: {
            enabled: true,
            callbacks: {
                label: (tooltipItem, data) => {
                    const dataset = data.datasets[tooltipItem.datasetIndex];
                    const total = dataset.data.reduce((prev, curr) => prev + curr);
                    const currentValue = dataset.data[tooltipItem.index];
                    const percentage = Math.floor(( ( currentValue / total ) * 100 ) + 0.5);
                    return ` ${percentage}%`;
                },
            },
        },
    };

    render() {
        const { stats, children } = this.props;

        return (
            <div className="ps-company-wrapper">
                <div className="ps-company-stats">
                    <Doughnut
                        data={stats.chartData()}
                        options={this.chartOptions}
                        width={250}
                        height={250}
                    />
                    <div className="chart-key m-t-15">
                        {
                            stats.stats().map((stat) => {
                                const style = { backgroundColor: stat.color() };

                                return (
                                    <span key={stat.id()}>
                                    <span className="badge-state" style={style}/>
                                        {stat.name()}
                                        <br/>
                                </span>
                                );
                            })
                        }
                    </div>
                </div>
                <div className="ps-company-children">
                    {children}
                </div>
            </div>
        );
    }
}

CompanyDocumentChart.propTypes = {
    stats: PropTypes.object.isRequired,
};

CompanyDocumentChart.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/stats/CompanyDocumentChart.jsx